import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconLikeFilled: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" boxSize={3} {...props}>
        <path
            d="m11.838 2h-0.838c-0.55228 0-1 0.44772-1 1v4c0 1.4117-0.59698 2-2 2-0.55578 0-1.0035 0.44772-1.0035 1v9.203c0 1.5419 0.4965 2.797 2.0327 2.797h8.4068c1.2875 0 2.396-0.90774 2.6816-2.1775l1.8132-8.0959 0.032625-0.16868c0.27434-1.6837-0.99652-3.2579-2.7135-3.2579l-3.79-1e-3 1e-3 -2.597c0-2.0379-1.6151-3.702-3.623-3.702z"
            fill="currentColor"
            fillRule="nonzero"
        />
        <rect x="2" y="9" width="3" height="12" rx="1" fill="currentColor" />
    </Icon>
);
